var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { ref: "top", staticClass: "observer" }),
      _vm._t("default"),
      _c("div", { ref: "bottom", staticClass: "observer" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }